<p>global-alerts-configurations works!</p>